export default "__VITE_ASSET__D30XoEdq__"